const SiteAlerts = (props: { alertData: string }) => {
  return (
    <>
      {props.alertData &&
        <div className="text-center bold" dangerouslySetInnerHTML={{ __html: props.alertData }}></div>
      }
    </>
  );
};

export default SiteAlerts;
